export default "__VITE_ASSET__BYN0gKTy__"